<header>
  <h4>
    {{ requestData.tipoSolicitacao }}
  </h4>
  <p>{{ requestData.criadoEm | date: 'dd/MM/yyyy' }}</p>
</header>
<div class="content">
  <scale-change-request-item
    [colaborador]="fromColaborador?.colaborador!"
    [dataTroca]="requestData.itemOrigem?.dataEscala!"
    [setor]="requestData.itemOrigem?.setor!"
    [turno]="requestData.itemOrigem?.turno!"
    [tipo]="requestData.tipoSolicitacao!"
    [direction]="'from'"
    [ngStyle]="{'background-color': itemColor}"
  />
  <div class="directions">
    <ion-icon *ngIf="requestData.tipoSolicitacao == tipoSolicitacao.TROCA" name="arrow-up-outline"></ion-icon>
    <ion-icon name="arrow-down-outline"></ion-icon>
  </div>

  <span [ngSwitch]="requestData.tipoSolicitacao">
    <ng-container *ngSwitchCase="tipoSolicitacao.TROCA">
      <ng-container *ngIf="requestData.tipoSolicitacao == tipoSolicitacao.TROCA && requestData.itensDestinoTroca[0] as itemDestino">
        <scale-change-request-item
          [colaborador]="toColaborador?.colaborador!"
          [dataTroca]="itemDestino.itemColaborador.dataEscala"
          [setor]="itemDestino.itemColaborador.setor"
          [turno]="itemDestino.itemColaborador.turno"
          [tipo]="requestData.tipoSolicitacao!"
          [direction]="'to'"
          [ngStyle]="{'background-color': itemColor}"
        />
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="tipoSolicitacao.PASSAGEM">
      <scale-change-request-item
        [colaborador]="toColaborador?.colaborador!"
        [dataTroca]="requestData.itemOrigem?.dataEscala!"
        [setor]="null"
        [turno]="null"
        [tipo]="requestData.tipoSolicitacao!"
        [direction]="'to'"
        [ngStyle]="{'background-color': itemColor}"
      />
    </ng-container>

    <ng-container *ngSwitchCase="tipoSolicitacao.REMANEJAMENTO">
      <ng-container *ngIf="requestData.destinoRemanejamento as remanejamento">
        <scale-change-request-item
          [colaborador]="null"
          [dataTroca]="remanejamento.data"
          [setor]="remanejamento.setor"
          [turno]="remanejamento.turno"
          [tipo]="requestData.tipoSolicitacao!"
          [direction]="'to'"
          [ngStyle]="{'background-color': itemColor}"
        />
      </ng-container>

    </ng-container>
    <ng-container *ngSwitchDefault>

    </ng-container>
  </span>

  <footer *ngIf="showFooter">
    <ion-button mode="ios" class="approve" (click)="approve.emit()">Aprovar</ion-button>
    <ion-button mode="ios" class="reprove" (click)="reprove.emit()">Reprovar</ion-button>
  </footer>
</div>
